/*eslint-disable */

import axios from 'axios';
import {bus} from '@/main';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let createCitationForAllApiUrl = root.createCitationForAllApiUrl.link;

export default {
  name: 'create-citation-for-all-papers',
  components: {
  },
  props: ['parentDATA'],
  data() {
    return {
      citationFormat:'',
      parentId:'',
      isSubmitted: false,
      searchResultPaperData:null,
      searchResultPapers:[],
      loader:false,
      folderInfo:null
    }
  },
  computed: {

  },
  mounted() {
    this.folderInfo = this.parentDATA
    this.parentId = this.folderInfo.id
  },
  methods: {
    urlClipBoardMethod(value) {
      navigator.clipboard.writeText(value);
    },
    citationBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.loader = true
          let payload = {
            bucket_id:this.parentId,
            format:this.citationFormat
          }
          axios.post(createCitationForAllApiUrl, payload).then((res) => {
            this.searchResultPaperData = res.data.data 
            this.searchResultPapers = this.searchResultPaperData.results
            this.loader = false
          }).catch((err) => {
            this.loader = false
          })
          return;
        }
      })
    },
    closeCitationPopupMethod(){
      bus.$emit('createCiteForAllPaperStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}